import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const minesRoundListColumns = [
  'minesRound._id',
  'minesRound.roundId',
  'minesRound.playerId',
  'minesRound.createdAt',
  'minesRound.roundHash',
  'minesRound.clientHash',
  'minesRound.serverHash',
] as const;

export type MinesRoundListColumns = (typeof minesRoundListColumns)[number];

export type MinesRoundListFilter = {
  'minesRound._id': string | undefined;
  'minesRound.roundId': string | undefined;
  'minesRound.playerId': string | undefined;
  'minesRound.createdAt': string | undefined;
  'minesRound.roundHash': string | undefined;
  'minesRound.clientHash': string | undefined;
  'minesRound.serverHash': string | undefined;
};

export const defaultMinesRoundListFilter: MinesRoundListFilter = {
  'minesRound._id': undefined,
  'minesRound.roundId': undefined,
  'minesRound.playerId': undefined,
  'minesRound.createdAt': undefined,
  'minesRound.roundHash': undefined,
  'minesRound.clientHash': undefined,
  'minesRound.serverHash': undefined,
};

export const minesRoundListColumnVisibilitySettings = {
  'minesRound._id': ColumnVisibilityType.Visible,
  'minesRound.roundId': ColumnVisibilityType.Visible,
  'minesRound.playerId': ColumnVisibilityType.CanBeHidden,
  'minesRound.createdAt': ColumnVisibilityType.CanBeHidden,
  'minesRound.roundHash': ColumnVisibilityType.CanBeHidden,
  'minesRound.clientHash': ColumnVisibilityType.CanBeHidden,
  'minesRound.serverHash': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<MinesRoundListColumns>;

export const defaultMinesRoundListColumnVisibility = defaultColumnVisibilityParams(
  minesRoundListColumnVisibilitySettings
);

export const minesRoundListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  minesRoundListColumns,
  minesRoundListColumnVisibilitySettings
);
